import { render, staticRenderFns } from "./lookLive.vue?vue&type=template&id=13bbf2d4&scoped=true&"
import script from "./lookLive.vue?vue&type=script&lang=js&"
export * from "./lookLive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13bbf2d4",
  null
  
)

export default component.exports